import React from "react";
import FindInPageIcon from "@mui/icons-material/Search";
import BackspaceIcon from "@mui/icons-material/Backspace";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { useStyles } from "./style";
import "./style.scss";

export function SearchDocPlace(props) {
  const classes = useStyles();
  const [searchField, setSearchField] = React.useState("");

  const searchItems = (term) => {
    props.callSearch(props.original ? term.trim() : term.toLowerCase().trim());
  };

  const handleChange = (e) => {
    setSearchField(e.target.value);
    searchItems(e.target.value);
    if (!e.target.value) {
      clear();
    }
  };
  const handleMouseDown = () => {
    setSearchField("");
    searchItems(" ");
    clear();
  };

  const clear = () => {
    if (props.clear) {
      props.clear();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && props.onClick) {
      props.onClick();
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div className={classes.searchContainer}>
        <div className={classes.baseSearch}>
          <FindInPageIcon className={classes.iconSearch} />
          <input
            type="text"
            value={searchField}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className={classes.inputSearch}
            placeholder="Search"
          />
          {props.loading && (
            <Tooltip title={props.loadingText || "Searching..."} placement="left">
              <span style={{ display: "flex", alignItems: "center", marginRight: 6 }}>
                <CircularProgress size={16} />
              </span>
            </Tooltip>
          )}
          {searchField && (
            <Tooltip title="clear search" placement="left">
              <BackspaceIcon
                onClick={handleMouseDown}
                className={classes.buttonSearch}
                alt="Delete"
              />
            </Tooltip>
          )}
        </div>
      </div>
      <Button
        className={classes.searchButton}
        variant="contained"
        size="small"
        onClick={props.onClick}
      >
        Search
      </Button>
    </div>
  );
}

export default SearchDocPlace;
